import { action } from 'satcheljs';
import type { MailEntrypoint } from 'owa-m365-acquisitions/lib/types';
import type { AppButtonOnExecuteParameter } from 'owa-acui';

type OnExecuteRibbonPinnedMessageExtension = {
    appId: string;
    entrypoint: MailEntrypoint;
    targetWindow: Window;
    itemId?: string;
    composeId?: string;
    params?: AppButtonOnExecuteParameter;
};

export interface OnExecuteRibbonPinnedMessageExtensionActionMessage {
    appId: string;
    entrypoint: MailEntrypoint;
    targetWindow: Window;
    itemId?: string;
    composeId?: string;
    params?: AppButtonOnExecuteParameter;
}

export const onExecuteRibbonPinnedMessageExtension: ({
    appId,
    itemId,
    composeId,
    entrypoint,
    targetWindow,
    params,
}: OnExecuteRibbonPinnedMessageExtension) => OnExecuteRibbonPinnedMessageExtensionActionMessage =
    action(
        'onExecuteRibbonPinnedMessageExtension',
        ({
            appId,
            itemId,
            composeId,
            entrypoint,
            targetWindow,
            params,
        }: OnExecuteRibbonPinnedMessageExtension): OnExecuteRibbonPinnedMessageExtensionActionMessage => ({
            appId,
            itemId,
            composeId,
            entrypoint,
            targetWindow,
            params,
        })
    );
